import { JsonObject, JsonProperty } from 'json2typescript';
import { DeleteResponseInterface } from '../interfaces/delete.interface';

@JsonObject('DeleteResponseModel')
export class DeleteResponseModel
  implements DeleteResponseInterface {
  @JsonProperty('Status', String, true)
  Status?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
